export interface Category {
  key: string;
  nameKey: string;
  url: string;
  imageSeq: string;
  imageQuery: string;
  priceFrom: string;
}

export const categories: Category[] = [
  {
    key: 'shoes',
    nameKey: 'cat.shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageSeq: 'cat-shoes-001',
    imageQuery: 'Stylish%20fashion%20sneakers%20and%20shoes%20on%20minimal%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20elegant%20composition%2C%20warm%20neutral%20tones%2C%20editorial%20style%2C%20high%20detail%2C%20shallow%20depth%20of%20field',
    priceFrom: 'от $12',
  },
  {
    key: 'hoodies',
    nameKey: 'cat.hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageSeq: 'cat-hoodies-002',
    imageQuery: 'Cozy%20oversized%20hoodie%20and%20sweater%20on%20warm%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20diffused%20lighting%2C%20clean%20aesthetic%2C%20neutral%20warm%20tones%2C%20editorial%20fashion%20style%2C%20high%20resolution%20texture%20detail',
    priceFrom: 'от $15',
  },
  {
    key: 'tshirts',
    nameKey: 'cat.tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageSeq: 'cat-tshirts-003',
    imageQuery: 'Premium%20cotton%20t-shirt%20folded%20on%20light%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20daylight%2C%20clean%20simple%20composition%2C%20warm%20neutral%20background%2C%20editorial%20style%2C%20textile%20texture%20visible',
    priceFrom: 'от $9',
  },
  {
    key: 'jackets',
    nameKey: 'cat.jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageSeq: 'cat-jackets-004',
    imageQuery: 'Modern%20stylish%20jacket%20displayed%20on%20minimal%20cream%20background%2C%20clean%20fashion%20product%20photography%2C%20soft%20studio%20lighting%2C%20elegant%20presentation%2C%20warm%20neutral%20aesthetic%2C%20high%20quality%20detail%2C%20contemporary%20style',
    priceFrom: 'от $22',
  },
  {
    key: 'pants',
    nameKey: 'cat.pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageSeq: 'cat-pants-005',
    imageQuery: 'Casual%20stylish%20pants%20and%20shorts%20on%20warm%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic%20composition%2C%20neutral%20warm%20tones%2C%20editorial%20fashion%20style%2C%20fabric%20texture%20detail',
    priceFrom: 'от $14',
  },
  {
    key: 'headwear',
    nameKey: 'cat.headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageSeq: 'cat-headwear-006',
    imageQuery: 'Trendy%20caps%20and%20beanies%20on%20light%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20diffused%20lighting%2C%20clean%20simple%20arrangement%2C%20warm%20neutral%20background%2C%20editorial%20style%2C%20accessory%20detail',
    priceFrom: 'от $6',
  },
  {
    key: 'sets',
    nameKey: 'cat.sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageSeq: 'cat-sets-007',
    imageQuery: 'Matching%20fashion%20clothing%20set%20on%20warm%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20clean%20elegant%20presentation%2C%20neutral%20warm%20tones%2C%20editorial%20style%2C%20coordinated%20outfit%20detail',
    priceFrom: 'от $25',
  },
  {
    key: 'underwear',
    nameKey: 'cat.underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageSeq: 'cat-underwear-008',
    imageQuery: 'Soft%20comfortable%20underwear%20on%20light%20cream%20surface%2C%20minimalist%20product%20photography%2C%20gentle%20diffused%20lighting%2C%20clean%20simple%20presentation%2C%20warm%20neutral%20background%2C%20editorial%20style%2C%20textile%20detail',
    priceFrom: 'от $5',
  },
  {
    key: 'jersey',
    nameKey: 'cat.jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageSeq: 'cat-jersey-009',
    imageQuery: 'Sports%20jersey%20displayed%20on%20warm%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20clean%20athletic%20aesthetic%2C%20neutral%20warm%20tones%2C%20editorial%20sportswear%20style%2C%20fabric%20detail',
    priceFrom: 'от $16',
  },
  {
    key: 'accessories',
    nameKey: 'cat.accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageSeq: 'cat-accessories-010',
    imageQuery: 'Various%20fashion%20accessories%20on%20light%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic%20arrangement%2C%20warm%20neutral%20background%2C%20editorial%20style%2C%20jewelry%20and%20accessory%20detail',
    priceFrom: 'от $4',
  },
  {
    key: 'bags',
    nameKey: 'cat.bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageSeq: 'cat-bags-011',
    imageQuery: 'Elegant%20fashion%20bag%20on%20warm%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20clean%20luxurious%20presentation%2C%20neutral%20warm%20tones%2C%20editorial%20style%2C%20leather%20texture%20detail',
    priceFrom: 'от $18',
  },
  {
    key: 'belts',
    nameKey: 'cat.belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageSeq: 'cat-belts-012',
    imageQuery: 'Stylish%20leather%20belt%20on%20light%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20simple%20presentation%2C%20warm%20neutral%20background%2C%20editorial%20style%2C%20buckle%20detail',
    priceFrom: 'от $7',
  },
  {
    key: 'perfumes',
    nameKey: 'cat.perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageSeq: 'cat-perfumes-013',
    imageQuery: 'Elegant%20perfume%20bottle%20on%20warm%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20clean%20luxurious%20aesthetic%2C%20neutral%20warm%20tones%2C%20editorial%20beauty%20style%2C%20glass%20detail%20and%20reflection',
    priceFrom: 'от $10',
  },
  {
    key: 'other',
    nameKey: 'cat.other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageSeq: 'cat-other-014',
    imageQuery: 'Assorted%20miscellaneous%20fashion%20items%20on%20light%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20diffused%20lighting%2C%20clean%20varied%20arrangement%2C%20warm%20neutral%20background%2C%20editorial%20style%2C%20diverse%20product%20detail',
    priceFrom: 'от $3',
  },
];